import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgbActiveModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ContainerService } from '../../Container/container.service';
import { ToasterService } from '../../toaster/toaster.service';
import { ContainerEyeViewData } from '../../Container/model/ContainerEyeViewData';
import { ContainerMovementListItem } from '../../Container/model/ContainerMovementListItem';
import { JobTypeEnum } from '../../Container/enum/JobTypeEnum';
import { AbstractContainerJobTypeHelper } from '../../Container/Helper/AbstractContainerJobTypeHelper';
import { ContainerJobDeliveryLocationDetailsComponent } from './container-job-delivery-location-details/container-job-delivery-location-details.component';
import { ContainerJobDetailsComponent } from "./container-job-details/container-job-details.component";
import { ContainerJobFromLocationDetailsComponent } from './container-job-from-location-details/container-job-from-location-details.component';
import { ContainerJobDehirePointDetailsComponent } from "./container-job-dehire-point-details/container-job-dehire-point-details.component";
import { ContainerJobLegDetailsComponent } from "./container-job-leg-details/container-job-leg-details.component";
import { ContainerJobAttachmentDetailsComponent } from "./container-job-attachment-details/container-job-attachment-details.component";

@Component({
  selector: 'app-container-job-eye-view-modal',
  standalone: true,
  imports: [NgbNavModule, ContainerJobDetailsComponent,
    ContainerJobFromLocationDetailsComponent,
    ContainerJobDeliveryLocationDetailsComponent,
    ContainerJobDehirePointDetailsComponent,
    ContainerJobLegDetailsComponent,
    ContainerJobAttachmentDetailsComponent],
  templateUrl: './container-job-eye-view-modal.component.html',
  styleUrl: './container-job-eye-view-modal.component.scss'
})
export class ContainerJobEyeViewModalComponent implements OnChanges, OnInit {

  @Input()
  containerJobItemId: number | null = null;
  containerLegId: number | null = 0;

  active = 1;
  isLoading: boolean = false;
  containerJobDetails: ContainerEyeViewData | null = null;
  containerLegsData: ContainerMovementListItem[] = [];
  currentLegData: ContainerMovementListItem | undefined;
  firstLeg: ContainerMovementListItem | undefined;
  lastLeg: ContainerMovementListItem | undefined;

  isInboundJob: boolean = false;
  isIntermodalJob: boolean = false;
  abstractContainerJobTypeHelper: AbstractContainerJobTypeHelper = new AbstractContainerJobTypeHelper();

  constructor(protected activeModal: NgbActiveModal,
    private containerService: ContainerService,
    private toasterService: ToasterService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['containerJobItemId']) {
      this.containerJobItemId = changes['containerJobItemId'].currentValue
      this.loadContainerJobDetails();
    }
  }

  ngOnInit(): void {
    this.loadContainerJobDetails();
  }

  loadContainerJobDetails() {
    this.isLoading = true;
    if (!this.containerJobItemId) {
      this.toasterService.show({
        text: 'No container job id provided',
        classname: 'bg-danger text-light',
        delay: 5000
      });
      this.activeModal.dismiss();
    } else {
      this.containerService.getContainerEyeViewData(this.containerJobItemId).subscribe(result => {
        this.containerJobDetails = result;

        this.containerLegsData = result.containerMovementListItems;
        const { firstLeg, lastLeg } = this.getFirstAndLastLeg(this.containerLegsData, (a, b) => a.sortOrder - b.sortOrder);

        if (this.containerLegId) {
          this.currentLegData = result.containerMovementListItems!.find((item: any) => item.containerLegId === this.containerLegId);
        } else {
          this.currentLegData = firstLeg;
        }

        if (firstLeg && lastLeg) {
          this.firstLeg = firstLeg;
          this.lastLeg = lastLeg;
        }

        if (this.currentLegData) {
          const jobType = JobTypeEnum[this.currentLegData.jobType as keyof typeof JobTypeEnum]
          this.isInboundJob = this.abstractContainerJobTypeHelper.isInboundJob(jobType);
          this.isIntermodalJob = this.abstractContainerJobTypeHelper.isIntermodalJob(jobType);
        }

        this.isLoading = false;
      });
    }
  }

  getFirstAndLastLeg<T>(array: T[], compareFn: (a: T, b: T) => number): { firstLeg: T, lastLeg: T } {
    if (!array || array.length === 0) {
      throw new Error('Array is empty or undefined');
    }

    const sortedArray = array.sort(compareFn);
    return {
      firstLeg: sortedArray[0],
      lastLeg: sortedArray[sortedArray.length - 1]
    };
  }

  getContainerNumber(): string {
    if (this.currentLegData && this.currentLegData.containerNumber) {
      return this.currentLegData.containerNumber;
    }
    return 'TBC';
  }
}
